import React from "react";
import { Row, Col } from "react-bootstrap";
import AnimatedRedirect from "../../assets/lottie/Redirect.json";
import Lottie from "lottie-react";
import "./RedirectError.css";
import Loginsvg from "../../assets/restricted.svg";
import CustomErrors from "../../constants/Errors";
import { useNavigate } from "react-router";

function RedirectError() {
  const navigate = useNavigate();

  return (
    <div>
      <div className="container red-con">
        <Row className="red-row">
          <Col className="lot-svg">
            <img src={Loginsvg} />
          </Col>
          <Col>
            <div className="mx-auto text-center">
              <h6 className="red-msg">Cant Redirect to this Page</h6>

              <p className="msg-para">{CustomErrors.UNAUTHORIZED_ACCESS}</p>

              <button
                role="button"
                className="redirect mx-auto"
                onClick={() => navigate("/")}
              >
                <span class="text">Go to Home</span>
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default RedirectError;
